import { ProcessorDetails } from '@/lib/api/processors';
import { ProcessorHeader } from '../components/processor-header';
import { ProcessorOverviewCard } from '../components/processor-overview-card';
import { ProcessorMetricsCard } from '../components/processor-metrics-card';

interface KessPayProcessorDetailsPageProps {
  processor: ProcessorDetails;
}

export const KessPayProcessorDetailsPage = ({ processor }: KessPayProcessorDetailsPageProps) => {
  return (
    <>
      <ProcessorHeader type="kesspay" processor={processor} />
      <ProcessorOverviewCard processor={processor} />
      <ProcessorMetricsCard processor={processor} />
    </>
  );
};
